export const gitCommit = '4aea271a'
